<mat-form-field class="example-full-width" style="width: 100%">
    <mat-icon style="margin-top: 10px;">record_voice_over</mat-icon>
    <input style="font-size: 22px; margin-left: 28px; color: black;  height: 49px; margin-top: -34px;" matInput disabled
        value="User Roles">
</mat-form-field>